import { SocketContext } from "contexts/SocketContext";
import { useContext } from "react";

export function useSocket() {
  const context = useContext(SocketContext);
  return context;
}
